/* Rore Active — theme.js */

const EVENTS = {
  CART_POPDOWN:   'theme:cart:popdown',
  CART_RELOAD:    'theme:cart:reload',
  CART_CHANGE:    'theme:cart:change',
  VARIANT_CHANGE: 'theme:variant:change'
};

// ─── Utility ──────────────────────────────────────────────────────────────────

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// ─── Drawer system ────────────────────────────────────────────────────────────
// State: aria-hidden="false" = open, aria-hidden="true" = closed.
// body.drawer-is-open locks scroll.
// Triggers: [data-drawer-toggle="<id>"], [data-close-drawer="<id>"], Escape.

function openDrawer(id) {
  var drawer = document.getElementById(id);
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('drawer-is-open');
  var toggle = document.querySelector('[data-drawer-toggle="' + id + '"]');
  if (toggle) toggle.setAttribute('aria-expanded', 'true');
}

function closeDrawer(id) {
  var drawer = document.getElementById(id);
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('drawer-is-open');
  var toggle = document.querySelector('[data-drawer-toggle="' + id + '"]');
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
}

window.openDrawer  = openDrawer;
window.closeDrawer = closeDrawer;

// Safety net: several components lock scroll with body.style.overflow. If none of them
// is actually open anymore, drop any leftover lock (dialog closed by back gesture, bfcache restore…).
function releaseStaleScrollLock() {
  if (document.body.classList.contains('drawer-is-open')) return;
  if (document.querySelector('dialog[open], .search-drawer.is-open, .filter-drawer.is-open')) return;
  document.body.style.overflow = '';
  document.body.style.position = '';
}
document.addEventListener('close', function() { setTimeout(releaseStaleScrollLock, 0); }, true);
window.addEventListener('pageshow', releaseStaleScrollLock);

document.addEventListener('click', function(e) {
  var toggle = e.target.closest('[data-drawer-toggle]');
  if (toggle) {
    var id = toggle.getAttribute('data-drawer-toggle');
    var drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.getAttribute('aria-hidden') === 'false' ? closeDrawer(id) : openDrawer(id);
    return;
  }
  var closeBtn = e.target.closest('[data-close-drawer]');
  if (closeBtn) {
    closeDrawer(closeBtn.getAttribute('data-close-drawer'));
  }
});

document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('[data-drawer-toggle]').forEach(function(toggle) {
    var id = toggle.getAttribute('data-drawer-toggle');
    var drawer = document.getElementById(id);
    if (drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer(id);
  });
});

// ─── Sheet system ─────────────────────────────────────────────────────────────
// Bottom-slide panels. Triggers: [data-sheet-toggle="<id>"]

function initSheets() {
  function openSheet(id) {
    var sheet = document.getElementById(id);
    if (!sheet) return;
    sheet.classList.add('is-open');
    sheet.removeAttribute('aria-hidden');
  }

  function closeSheet(sheet) {
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-sheet-toggle]');
    if (toggle) { openSheet(toggle.dataset.sheetToggle); return; }
    var closeBtn = e.target.closest('[data-close-sheet]');
    if (closeBtn) {
      var sheet = closeBtn.closest('[data-sheet], .sheet');
      if (sheet) closeSheet(sheet);
      return;
    }
    if (e.target.classList.contains('sheet') && e.target.classList.contains('is-open')) {
      closeSheet(e.target);
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.sheet.is-open').forEach(closeSheet);
    }
  });
}

// ─── Search drawer ────────────────────────────────────────────────────────────

function initSearchDrawer() {
  var drawer      = document.getElementById('search-drawer');
  var results     = document.getElementById('search-predictive-results');
  var suggestions = drawer && drawer.querySelector('[data-search-suggestions]');
  if (!drawer) return;

  if (document.body.classList.contains('has-banner')) drawer.classList.add('has-banner');

  var searchForm = drawer.querySelector('.search-drawer__form');
  if (searchForm) {
    searchForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var input = searchForm.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) return;
      var params = new URLSearchParams(new FormData(searchForm));
      params.set('q', input.value.trim() + '*');
      window.location.href = (searchForm.action || '/search') + '?' + params.toString();
    });
  }

  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-search-toggle]');
    if (!toggle) return;
    var isOpen = drawer.classList.contains('is-open');
    drawer.classList.toggle('is-open', !isOpen);
    if (!isOpen) {
      var input = drawer.querySelector('input[type="search"], input[name="q"]');
      if (input) setTimeout(function() { input.focus(); }, 50);
    } else {
      // Reset on close
      if (results) { results.innerHTML = ''; results.hidden = true; }
      if (suggestions) suggestions.hidden = false;
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      drawer.classList.remove('is-open');
      if (results) { results.innerHTML = ''; results.hidden = true; }
      if (suggestions) suggestions.hidden = false;
    }
  });

  var searchTimeout;
  drawer.addEventListener('input', function(e) {
    if (!e.target.matches('input[type="search"], input[name="q"]')) return;
    clearTimeout(searchTimeout);
    var q = e.target.value.trim();
    if (!results) return;
    if (q.length < 2) {
      results.innerHTML = '';
      results.hidden = true;
      if (suggestions) suggestions.hidden = false;
      return;
    }
    results.hidden = false;
    if (suggestions) suggestions.hidden = true;
    searchTimeout = setTimeout(function() {
      var url = theme.routes.predictive_search_url +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product' +
        '&resources[limit]=8&section_id=predictive-search';
      fetch(url)
        .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function(html) {
          var doc   = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.getElementById('shopify-section-predictive-search');
          results.innerHTML = inner ? inner.innerHTML : '';
        })
        .catch(function(err) { console.error('[Search]', err); });
    }, 300);
  });
}

// ─── Gallery thumbnail swap (product page) ────────────────────────────────────

function initGallery() {
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var id = thumb.dataset.galleryThumb;
    gallery.querySelectorAll('[data-gallery-main]').forEach(function(el) {
      el.hidden = el.dataset.galleryMain !== id;
    });
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function(el) {
      el.classList.toggle('is-active', el.dataset.galleryThumb === id);
    });
  });
}

// ─── Accordion (JS-driven, not details/summary) ───────────────────────────────

function initAccordions() {
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-accordion-toggle]');
    if (!toggle) return;
    var accordion = toggle.closest('[data-accordion]');
    if (!accordion) return;
    accordion.classList.toggle('is-open');
  });
}

// ─── Viewport height on resize ────────────────────────────────────────────────

var vhTimeout;
window.addEventListener('resize', function() {
  clearTimeout(vhTimeout);
  vhTimeout = setTimeout(function() {
    document.documentElement.style.setProperty('--1vh', (window.innerHeight * 0.01) + 'px');
  }, 100);
});

// ─── Cart count badge sync ────────────────────────────────────────────────────

document.addEventListener(EVENTS.CART_CHANGE, function(e) {
  var count = e.detail && e.detail.cart ? e.detail.cart.item_count : 0;
  document.querySelectorAll('[data-cart-count]').forEach(function(el) {
    el.textContent = count;
    el.hidden = count === 0;
  });
});

// ─── Cart popdown chain ───────────────────────────────────────────────────────
// After ATC: reload cart state, then open cart drawer after 500ms.

document.addEventListener(EVENTS.CART_POPDOWN, function() {
  document.dispatchEvent(new CustomEvent(EVENTS.CART_RELOAD, { bubbles: true }));
  setTimeout(function() { openDrawer('drawer-cart'); }, 500);
});

// ─── Cart reload ──────────────────────────────────────────────────────────────

function _cartRenderItems() {
  return fetch('/cart?sections=cart-items', { cache: 'no-store' })
    .then(function(r) { return r.json(); })
    .then(function(sections) {
      var sectionHtml = sections && sections['cart-items'];
      if (sectionHtml) {
        var doc           = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var newItems      = doc.querySelector('.cart-items');
        var existingItems = document.querySelector('.cart-items');
        if (newItems && existingItems) existingItems.replaceWith(newItems);
      }
    });
}

document.addEventListener(EVENTS.CART_RELOAD, function() {
  Promise.all([
    fetch('/cart.js', { cache: 'no-store' }).then(function(r) { return r.json(); }),
    _cartRenderItems()
  ])
    .then(function(results) {
      document.dispatchEvent(new CustomEvent(EVENTS.CART_CHANGE, {
        detail:  { cart: results[0] },
        bubbles: true
      }));
    })
    .catch(function(err) { console.error('CART_RELOAD error:', err); });
});

// ─── BIS (back in stock / notify me) ─────────────────────────────────────────

function triggerBIS() {
  var el = document.getElementById('BIS_trigger');
  if (!el) return;
  // Click the first interactive child Klaviyo may have injected, or the div itself
  var inner = el.querySelector('a, button');
  (inner || el).click();
}

// Product page: notify button click → trigger Klaviyo dialog
document.addEventListener('click', function(e) {
  if (!e.target.closest('[data-notify-btn]')) return;
  triggerBIS();
});

// Collection cards: notify badge → go to product page and auto-open BIS modal
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-card-notify]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  window.location = '/products/' + btn.dataset.bisHandle + '?notify=1';
});

// Product page: auto-trigger BIS modal when arriving via ?notify=1
(function() {
  if (window.location.pathname.indexOf('/products/') !== 0) return;
  if (new URLSearchParams(window.location.search).get('notify') !== '1') return;
  function tryTrigger(attempts) {
    var el = document.getElementById('BIS_trigger');
    if (el && el.querySelector('a, button')) {
      var inner = el.querySelector('a, button');
      inner.click();
      return;
    }
    if (attempts > 0) setTimeout(function() { tryTrigger(attempts - 1); }, 200);
  }
  document.addEventListener('DOMContentLoaded', function() { tryTrigger(20); });
})();

// ─── Desktop size bar → direct ATC (no modal) ─────────────────────────────────

document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-atc-size]');
  if (!btn || btn.closest('#quick-add-dialog')) return;
  e.preventDefault();
  btn.disabled = true;
  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ id: Number(btn.dataset.atcSize), quantity: 1 })
  })
    .then(function() {
      document.dispatchEvent(new CustomEvent(EVENTS.CART_POPDOWN, { bubbles: true }));
    })
    .catch(function(err) { console.error(err); btn.disabled = false; });
});

// ─── Desktop quick-add → toggle inline size bar ───────────────────────────────

document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  if (!window.matchMedia('(hover: hover)').matches) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  var card = btn.closest('.product-card');
  if (card) card.classList.toggle('is-size-bar-open');
});

document.addEventListener('mouseleave', function(e) {
  if (e.target && e.target.classList && e.target.classList.contains('product-card')) {
    e.target.classList.remove('is-size-bar-open');
  }
}, true);

// ─── Quick-add → <dialog> modal ───────────────────────────────────────────────

document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  e.preventDefault();

  var handle      = btn.dataset.quickAdd;
  var barometre   = btn.dataset.barometre || '';
  var productId   = btn.dataset.productId || '';
  var dialog      = document.getElementById('quick-add-dialog');
  if (!dialog) return;

  var titleEl    = dialog.querySelector('.quick-add-dialog__product-title');
  var imagesEl   = dialog.querySelector('.quick-add-dialog__images');
  var sizesEl    = dialog.querySelector('.quick-add-dialog__sizes');
  var noteEl     = dialog.querySelector('.quick-add-dialog__sizing-note');
  var fitleEl    = dialog.querySelector('#quick-add-fitle');
  var atcBtn     = dialog.querySelector('.quick-add-dialog__atc');

  // Sizing note from barometre metafield
  var strings = window.theme.strings;
  var barometreMap = {
    'Petit':       strings.barometreSmall,
    'Moyen-Petit': strings.barometreSlightlySmall,
    'Moyen-Grand': strings.barometreSlightlyLarge,
    'Grand':       strings.barometreLarge
  };
  if (noteEl) noteEl.textContent = barometreMap[barometre] || strings.barometreNormal;

  // Reset Fitle
  if (fitleEl) { fitleEl.setAttribute('productId', productId); fitleEl.setAttribute('availableSizes', ''); }

  titleEl.textContent      = '';
  imagesEl.innerHTML       = '';
  sizesEl.innerHTML        = '';
  atcBtn.disabled          = true;
  atcBtn.dataset.variantId = '';

  dialog.showModal();
  document.body.style.overflow = 'hidden';

  fetch('/products/' + handle + '.js')
    .then(function(r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' for /products/' + handle + '.js');
      return r.json();
    })
    .then(function(product) {
      titleEl.textContent = product.title;

      imagesEl.innerHTML = product.images.map(function(imgUrl) {
        return '<a href="/products/' + handle + '"><img src="' + imgUrl + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></a>';
      }).join('');

      var options = product.options || [];
      var sizeOptIdx = options.findIndex(function(o) {
        var name = typeof o === 'string' ? o : (o.name || '');
        return /^taille$|^size$/i.test(name.trim());
      });
      if (sizeOptIdx === -1) sizeOptIdx = 0;
      var optKey = 'option' + (sizeOptIdx + 1);

      sizesEl.innerHTML = product.variants.map(function(v) {
        var label = v[optKey] || v.title;
        return v.available
          ? '<button class="size-pill" data-atc-size="' + v.id + '">' + escapeHtml(label) + '</button>'
          : '<button class="size-pill is-unavailable" disabled>' + escapeHtml(label) + '</button>';
      }).join('');

      var availablePills = Array.from(sizesEl.querySelectorAll('.size-pill:not([disabled])'));

      availablePills.forEach(function(pill) {
        pill.addEventListener('click', function() {
          sizesEl.querySelectorAll('.size-pill').forEach(function(p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          atcBtn.disabled          = false;
          atcBtn.dataset.variantId = pill.dataset.atcSize;
        });
      });

      if (availablePills.length > 0) {
        availablePills[0].click();
      }

      // Update Fitle with available sizes and product image
      if (fitleEl) {
        var availableSizes = product.variants
          .filter(function(v) { return v.available; })
          .map(function(v) { return v[optKey] || v.title; })
          .join(',');
        fitleEl.setAttribute('availableSizes', availableSizes);
        if (product.images && product.images[0]) fitleEl.setAttribute('productImageUrl', product.images[0]);
      }
    })
    .catch(function(err) {
      console.error('[Quick Add]', handle, err);
      sizesEl.innerHTML = '<p style="padding:1rem">' + (theme.strings.loadError || 'Erreur lors du chargement.') + '</p>';
    });

  atcBtn.onclick = function() {
    var variantId = Number(atcBtn.dataset.variantId);
    if (!variantId) return;
    atcBtn.disabled = true;
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function() {
        dialog.close();
        document.dispatchEvent(new CustomEvent(EVENTS.CART_POPDOWN, { bubbles: true }));
      })
      .catch(function() { atcBtn.disabled = false; });
  };
});

// ─── Skeleton card builder ────────────────────────────────────────────────────

function buildSkeletonCard() {
  return '<article class="product-card product-card--skeleton" aria-hidden="true">' +
    '<div class="product-card__media"><div class="product-card__skeleton-img"></div></div>' +
    '<div class="product-card__info">' +
      '<div class="product-card__skeleton-swatches"><span></span><span></span><span></span><span></span><span></span></div>' +
      '<div class="product-card__skeleton-line product-card__skeleton-line--title"></div>' +
      '<div class="product-card__skeleton-line product-card__skeleton-line--subtitle"></div>' +
      '<div class="product-card__skeleton-line product-card__skeleton-line--price"></div>' +
    '</div>' +
  '</article>';
}

window.rore = window.rore || {};
window.rore.buildSkeletonCard = buildSkeletonCard;

// ─── Popout selectors (locale / currency) ─────────────────────────────────────

document.addEventListener('click', function(e) {
  var toggle = e.target.closest('[data-popout-toggle]');
  if (toggle) {
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    document.querySelectorAll('[data-popout-toggle][aria-expanded="true"]').forEach(function(t) {
      if (t !== toggle) t.setAttribute('aria-expanded', 'false');
    });
    toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    return;
  }
  if (!e.target.closest('[data-popout]')) {
    document.querySelectorAll('[data-popout-toggle][aria-expanded="true"]').forEach(function(t) {
      t.setAttribute('aria-expanded', 'false');
    });
  }
});

document.addEventListener('click', function(e) {
  var option = e.target.closest('[data-popout-option]');
  if (!option) return;
  e.preventDefault();
  var value  = option.dataset.value;
  var popout = option.closest('[data-popout]');
  var input  = popout && popout.querySelector('[data-popout-input]');
  var form   = popout && popout.closest('form');
  if (input && form) { input.value = value; form.submit(); }
});

// ─── Cart item quantity / remove ──────────────────────────────────────────────

document.addEventListener('click', function(e) {
  var inc = e.target.closest('[data-cart-increase]');
  if (inc) {
    if (inc.disabled) return;
    _cartAdjust(inc.dataset.cartIncrease, 1);
    return;
  }
  var dec = e.target.closest('[data-cart-decrease]');
  if (dec) { _cartAdjust(dec.dataset.cartDecrease, -1); return; }
  var rem = e.target.closest('[data-cart-remove]');
  if (rem) { _cartSetQty(rem.dataset.cartRemove, 0);    return; }
});

function _cartAdjust(key, delta) {
  var item   = document.querySelector('[data-cart-item][data-item-key="' + key + '"]');
  var qtyEl  = item && item.querySelector('[data-item-qty]');
  var qty    = parseInt((qtyEl || {}).textContent, 10) || 0;
  var newQty = Math.max(0, qty + delta);
  var incBtn = item && item.querySelector('[data-cart-increase]');
  if (incBtn) {
    var max = parseInt(incBtn.dataset.maxQty, 10);
    var atMax = max > 0 && newQty >= max;
    if (atMax) newQty = max;
    incBtn.disabled = atMax;
    incBtn.toggleAttribute('aria-disabled', atMax);
  }
  _cartSetQty(key, newQty);
}

function _cartSetQty(key, qty) {
  var item    = document.querySelector('[data-cart-item][data-item-key="' + key + '"]');
  var qtyEl   = item && item.querySelector('[data-item-qty]');
  var prevQty = qtyEl ? (parseInt(qtyEl.textContent, 10) || 0) : 0;

  // Lock all controls on this line while the request is in flight
  var btns = item ? item.querySelectorAll('[data-cart-increase],[data-cart-decrease],[data-cart-remove]') : [];
  btns.forEach(function(b) { b.disabled = true; });

  if (qty === 0 && item) {
    item.remove();
  } else if (qtyEl) {
    qtyEl.textContent = qty;
  }

  fetch('/cart/change.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ id: key, quantity: qty })
  })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      return _cartRenderItems().then(function() {
        document.dispatchEvent(new CustomEvent(EVENTS.CART_CHANGE, {
          detail:  { cart: cart },
          bubbles: true
        }));
      });
    })
    .catch(function(err) {
      console.error('cart/change.js error:', err);
      // Restore optimistic changes on error
      var el = document.querySelector('[data-cart-item][data-item-key="' + key + '"]');
      if (el) {
        var qEl = el.querySelector('[data-item-qty]');
        if (qEl) qEl.textContent = prevQty;
        el.querySelectorAll('[data-cart-increase],[data-cart-decrease],[data-cart-remove]').forEach(function(b) { b.disabled = false; });
      }
    });
}

// ─── Gift bar + totals ────────────────────────────────────────────────────────

document.addEventListener(EVENTS.CART_CHANGE, function(e) {
  var cart = e.detail && e.detail.cart;
  if (!cart) return;

  // Total excluding insurance
  var adjustedTotal = cart.items.reduce(function(sum, item) {
    return item.handle === 'protection-commande' ? sum : sum + item.final_line_price;
  }, 0);

  // Update total (show full price the customer pays)
  var totalEl = document.querySelector('[data-cart-total]');
  if (totalEl) totalEl.textContent = _cartMoney(cart.total_price);

  // Empty / has-items toggle
  var isEmpty = cart.item_count === 0;
  document.querySelectorAll('[data-cart-has-items]').forEach(function(el) { el.hidden = isEmpty; });
  document.querySelectorAll('[data-cart-is-empty]').forEach(function(el)  { el.hidden = !isEmpty; });
  document.querySelectorAll('[data-cart-footer]').forEach(function(el)    { el.hidden = isEmpty; });
  var giftBar = document.querySelector('[data-gift-bar]');
  if (giftBar) giftBar.hidden = isEmpty;

  var shippingLine = document.querySelector('[data-shipping-line]');
  if (shippingLine) {
    var shippingThreshold = parseInt(shippingLine.dataset.shippingThreshold, 10);
    var belowThreshold = isEmpty || adjustedTotal < shippingThreshold;
    shippingLine.hidden = belowThreshold;
    var shippingCalculated = document.querySelector('[data-shipping-calculated]');
    if (shippingCalculated) shippingCalculated.hidden = isEmpty || !belowThreshold;
  }
  var cartBody = document.querySelector('.cart-drawer__body');
  if (cartBody) cartBody.classList.toggle('cart-drawer__body--empty', isEmpty);

  // Gift bar (uses adjusted total, not full total)
  var bar = document.querySelector('[data-gift-bar]');
  if (!bar) return;
  var threshold = parseInt(bar.dataset.threshold, 10);
  if (!threshold) return;
  var fill = bar.querySelector('[data-gift-bar-fill]');
  var text = bar.querySelector('[data-gift-bar-text]');
  var pct  = Math.min(100, (adjustedTotal / threshold) * 100);
  if (fill) fill.style.width = pct.toFixed(1) + '%';
  if (text) {
    if (adjustedTotal >= threshold) {
      text.textContent = bar.dataset.msgUnlocked || '';
    } else {
      var remaining = Math.ceil((threshold - adjustedTotal) / 100);
      text.textContent = (bar.dataset.msgProgress || '').replace('REPLACE_AMOUNT', remaining);
    }
  }
});

function _cartMoney(cents) {
  var n = cents / 100;
  return (Number.isInteger(n) ? n.toString() : n.toFixed(2).replace('.', ',')) + ' €';
}

// ─── Collection infinite scroll ───────────────────────────────────────────────

function initInfiniteScroll() {
  var trigger = document.querySelector('[data-js-load-more]');
  if (!trigger) return;

  var grid      = document.querySelector('[data-collection-grid]');
  var isLoading = false;

  var observer = new IntersectionObserver(function(entries) {
    if (!entries[0].isIntersecting || isLoading) return;

    var nextUrl = trigger.dataset.nextLink;
    if (!nextUrl) { observer.disconnect(); return; }

    isLoading = true;

    fetch(nextUrl)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc      = new DOMParser().parseFromString(html, 'text/html');
        var newCards = doc.querySelectorAll('[data-collection-grid] .product-card');
        newCards.forEach(function(card) { grid.appendChild(card); });

        var newTrigger = doc.querySelector('[data-js-load-more]');
        if (newTrigger) {
          trigger.dataset.nextLink  = newTrigger.dataset.nextLink;
          trigger.dataset.thisPage  = newTrigger.dataset.thisPage;
        } else {
          observer.disconnect();
          trigger.remove();
        }
        isLoading = false;
      })
      .catch(function() { isLoading = false; });
  }, { rootMargin: '300px' });

  observer.observe(trigger);
}

// ─── Init ─────────────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', function() {
  initSheets();
  initSearchDrawer();
  initGallery();
  initAccordions();
  initInfiniteScroll();

  var quickAddDialog = document.getElementById('quick-add-dialog');
  if (quickAddDialog) {
    quickAddDialog.querySelector('.quick-add-dialog__close').addEventListener('click', function() {
      quickAddDialog.close();
    });
    quickAddDialog.addEventListener('click', function(e) {
      if (e.target === quickAddDialog) quickAddDialog.close();
    });
    quickAddDialog.addEventListener('close', function() {
      document.body.style.overflow = '';
    });
  }

  document.querySelectorAll('[data-product-slider-track]').forEach(function(track) {
    var container = track.closest('[data-product-slider-progress]');
    if (!container) return;
    var bar = container.querySelector('.product-slider__progress-bar');
    if (!bar) return;
    function updateProgress() {
      var max = track.scrollWidth - track.clientWidth;
      bar.style.width = max <= 0 ? '100%' : (track.scrollLeft / max * 100) + '%';
    }
    track.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  });

  // ── Sticky header ────────────────────────────────────────────────────────────
  var siteHeader   = document.querySelector('.site-header');
  var mobileDrawer = document.getElementById('drawer-mobile-nav');
  var searchDrawer = document.getElementById('search-drawer');
  if (siteHeader || mobileDrawer) {
    var wasClear = siteHeader && siteHeader.classList.contains('is-clear');
    function applyScrollState() {
      var past = window.scrollY > 40;
      if (siteHeader) {
        siteHeader.classList.toggle('fixed', past);
        if (wasClear) siteHeader.classList.toggle('is-clear', !past);
      }
      if (mobileDrawer) mobileDrawer.classList.toggle('fixed', past);
      if (searchDrawer) searchDrawer.classList.toggle('fixed', past);
    }
    applyScrollState();
    window.addEventListener('scroll', applyScrollState, { passive: true });
  }

  var maillagesEl = document.querySelector('.maillages-container');
  if (maillagesEl) {
    var isDown = false, startX, scrollLeft, velocity = 0, rafId;
    maillagesEl.addEventListener('mousedown', function(e) {
      isDown = true;
      startX = e.pageX - maillagesEl.offsetLeft;
      scrollLeft = maillagesEl.scrollLeft;
      velocity = 0;
      cancelAnimationFrame(rafId);
    });
    document.addEventListener('mouseup', function() {
      if (!isDown) return;
      isDown = false;
      applyMomentum();
    });
    maillagesEl.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - maillagesEl.offsetLeft;
      var prev = maillagesEl.scrollLeft;
      maillagesEl.scrollLeft = scrollLeft - (x - startX);
      velocity = maillagesEl.scrollLeft - prev;
    });
    function applyMomentum() {
      if (Math.abs(velocity) < 0.5) return;
      maillagesEl.scrollLeft += velocity;
      velocity *= 0.95;
      rafId = requestAnimationFrame(applyMomentum);
    }
  }
});

// ── Insurance / Protection commande toggle ────────────────────────────────────
(function () {

  function getInsuranceTiers() {
    var label = document.querySelector('[data-insurance-label]');
    try { return JSON.parse((label && label.dataset.insuranceTiers) || '[]'); } catch(e) { return []; }
  }

  function getTierForTotal(adjustedTotal) {
    var tiers = getInsuranceTiers();
    for (var i = 0; i < tiers.length; i++) {
      if (adjustedTotal <= tiers[i].threshold) return tiers[i];
    }
    return tiers[tiers.length - 1] || null;
  }

  function applyInsuranceTier(tier) {
    if (!tier) return;
    var cb = document.getElementById('cart-insurance-toggle');
    if (cb) cb.dataset.variantId = tier.id;
    var priceEl = document.querySelector('[data-insurance-price]');
    if (priceEl) priceEl.textContent = tier.price;
  }

  function getInsuranceVariantId() {
    var cb = document.getElementById('cart-insurance-toggle');
    return cb ? parseInt(cb.dataset.variantId, 10) : 0;
  }

  function getInsuranceItemInCart(cart) {
    return cart.items.find(function(i) { return i.handle === 'protection-commande'; });
  }

  function isInsuranceInCart(cart) {
    return !!getInsuranceItemInCart(cart);
  }

  function syncCheckbox(inCart) {
    var cb = document.getElementById('cart-insurance-toggle');
    if (cb) cb.checked = inCart;
  }

  function fetchCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function dispatchCartChange(cart) {
    document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));
  }

  // On every cart change: update tier display, swap variant in cart if tier changed
  document.addEventListener('theme:cart:change', function(e) {
    var cart = e.detail && e.detail.cart;
    if (!cart) return;

    var adjustedTotal = cart.items.reduce(function(sum, item) {
      return item.handle === 'protection-commande' ? sum : sum + item.final_line_price;
    }, 0);

    var newTier = getTierForTotal(adjustedTotal);
    if (!newTier) { syncCheckbox(isInsuranceInCart(cart)); return; }

    var oldVariantId = getInsuranceVariantId();
    applyInsuranceTier(newTier);

    if (newTier.id !== oldVariantId) {
      var oldItem = getInsuranceItemInCart(cart);
      if (oldItem) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: oldItem.key, quantity: 0 })
        })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: newTier.id, quantity: 1 }] })
          });
        })
        .then(function() { return fetchCart(); })
        .then(dispatchCartChange);
        return;
      }
    }

    syncCheckbox(isInsuranceInCart(cart));
  });

  // Initial sync when drawer opens
  document.addEventListener('theme:drawer:open', function(e) {
    if (e.detail && e.detail.id !== 'drawer-cart') return;
    fetchCart().then(function(cart) { syncCheckbox(isInsuranceInCart(cart)); });
  });

  // Toggle handler
  document.addEventListener('change', function(e) {
    var cb = e.target.closest('[data-insurance-toggle]');
    if (!cb) return;

    var adding = cb.checked;
    cb.disabled = true;
    var variantId = getInsuranceVariantId();

    var request = adding
      ? Promise.resolve(JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }))
      : fetchCart().then(function(cart) {
          var item = getInsuranceItemInCart(cart);
          return JSON.stringify({ id: item ? item.key : variantId, quantity: 0 });
        });

    request
      .then(function(body) {
        return fetch(adding ? '/cart/add.js' : '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body
        });
      })
      .then(function(r) {
        if (!r.ok) throw new Error('cart error');
        return fetchCart();
      })
      .then(function(cart) {
        cb.disabled = false;
        dispatchCartChange(cart);
      })
      .catch(function() {
        cb.disabled = false;
        cb.checked = !cb.checked;
      });
  });
})();

// ─── Newsletter forms ──────────────────────────────────────────────────────────

document.addEventListener('submit', function(e) {
  var form = e.target.closest('[data-newsletter-form]');
  if (!form) return;
  e.preventDefault();
  fetch(form.action, {
    method: 'POST',
    body: new FormData(form),
    credentials: 'include'
  }).catch(function() {});
  var emailInput = form.querySelector('[name="contact[email]"]');
  if (emailInput && emailInput.value.trim()) {
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RGyaVQ', {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2023-12-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: emailInput.value.trim() } } }
          },
          relationships: { list: { data: { type: 'list', id: 'WePvV2' } } }
        }
      })
    }).catch(function() {});
  }
  var btn = form.querySelector('.newsletter-bar__submit');
  if (btn) {
    btn.classList.add('is-sent');
    setTimeout(function() { btn.classList.remove('is-sent'); }, 2000);
  }
});
